'use strict';

var _ = require('lodash');
var TrendChartDowAggregationFactory = function TrendChartDowAggregationFactory(DataAggregationFactory, momentService, $filter, optWeekService) {
  var rmMomentFormat = $filter('rmMomentFormat');
  function DOWComparator(a, b) {
    return optWeekService.getIndexOfDayOfWeek(a.d1) - optWeekService.getIndexOfDayOfWeek(b.d1);
  }
  function dateComparator(a, b) {
    return a.d1.valueOf() - b.d1.valueOf();
  }
  function TrendChartDowAggregation() {
    DataAggregationFactory.call(this, 'rom-analysis-flattened-services-mode', 'trend-chart-dow');
  }
  TrendChartDowAggregation.prototype = Object.create(DataAggregationFactory.prototype);
  TrendChartDowAggregation.constructor = TrendChartDowAggregation;
  TrendChartDowAggregation.prototype.aggregate = function (data, metricsKeys) {
    var resultMap = {};
    for (var i = 0; i < data.length; i++) {
      var record = data[i];
      resultMap[record.dow] = resultMap[record.dow] || {};
      var departureDate = record.departureDate;
      var currentDowData = resultMap[record.dow];
      currentDowData[departureDate] = currentDowData[departureDate] || {
        m1: 0,
        m2: 0,
        d1: record.departureDateMoment,
        stackLabel: rmMomentFormat(record.departureDateMoment, 'DATE_USER_SETTINGS')
      };
      var currentDepDayData = currentDowData[departureDate];
      currentDepDayData.m1 += this.getMetricValue(record.spillPaxGap, metricsKeys, true);
      currentDepDayData.m2 += this.getMetricValue(record.recapPaxGap, metricsKeys, true);
    }
    var result = _.transform(resultMap, function (result, value, key) {
      result.push({
        d1: key,
        containerData: _.values(value).sort(dateComparator)
      });
    }, []);
    result.sort(DOWComparator);
    return result;
  };
  return TrendChartDowAggregation;
};
TrendChartDowAggregationFactory.$inject = ['AbstractROMServiceAggregationFactory', 'MomentService', '$filter', 'OptWeekService'];
module.exports = TrendChartDowAggregationFactory;